import styled from 'styled-components';
import Lab119 from '../Lab119';
import { Typ20 } from '../Typ';

export const InnerWrapper = styled.div``;

export const TitleWrapper = styled.div`
  display: flex;
  height: 24px;
  justify-content: center;
  align-items: center;
`;

type LabelTitleProps = {
  $iconColor?: string;
  $themeName?: 'light' | 'dark';
};

export const LabelTitle = styled(Lab119)<LabelTitleProps>`
  > i:first-child {
    color: ${props => (props.$iconColor ? props.$iconColor : '#00ab97')};
    margin-right: 8px;
  }
  > span:last-child {
    color: ${props => (props.$themeName === 'dark' ? '#FFF' : '#263238')};
    margin: 0;
  }
`;

type ThemeProps = {
  $themeName?: 'light' | 'dark';
};

export const CaptionText = styled(Typ20)<ThemeProps>`
  height: 14px;
  display: flex;
  justify-content: center;
  color: ${props =>
    props.$themeName === 'dark' ? 'rgba(255, 255, 255, 0.40)' : '#90a4ae'};
`;
